import styled from "@emotion/styled";
import { Button } from "@mui/material";
export const StyledButton = styled(Button)(() => ({
  minWidth: "14vw",
  padding: 10,
  fontWeight: 700,
  fontSize: 17,
  textAlign: "center",
  textTransform: "uppercase",
  cursor: "pointer",
  border: "none",
  borderRadius: 10,
  color: "white",
  background: "#FEB25B",
}));
